import type { ReactNode } from "react";

import { PlatformLogo } from "@shared/components/PlatformLogo/PlatformLogo";
import { CountrySelect } from "@unauthenticated/signupSignin/components/CountrySelect/CountrySelect";

import * as styles from "./FullBleedShell.styles";

interface Props {
  panel: ReactNode;
  children: ReactNode;
  showCountrySelect?: boolean;
  showPlatformLogo?: boolean;
  afterContent?: ReactNode;
}

const FullBleedShell = ({
  panel,
  children,
  showCountrySelect = false,
  showPlatformLogo = false,
  afterContent,
}: Props) => (
  <div css={styles.fullBleedRow}>
    <div css={styles.panelColumn}>{panel}</div>
    <div css={styles.formColumn}>
      <div css={styles.formColumnInner}>
        {!!showCountrySelect && (
          <div css={styles.countrySelectRow}>
            <CountrySelect />
          </div>
        )}
        <div css={styles.formContent}>
          <div css={styles.formGroup}>
            {!!showPlatformLogo && (
              <div css={styles.logoContainer}>
                <PlatformLogo customCss={styles.logo} />
              </div>
            )}
            {children}
          </div>
          {afterContent}
        </div>
      </div>
    </div>
  </div>
);

export { FullBleedShell };
